import React, {useEffect, useState} from 'react';
import {Controller} from "react-hook-form";
import debounce from "lodash/debounce";
import {Autocomplete, TextField} from "@mui/material";
import {trafficSourceSelectPaperStyles} from "./TrafficSourceDesign";
import {customEventServices} from "../../service/customEventService";

function ReactHookCustomConversionSelect(
    {
        control,
        inputLabel = "Select custom conversions",
        inputName = "selectedCustomConversion",
        updateOnChange = () => null,
        disabledOptions = [],
        errors
    }
) {

    const selectId = React.useId();
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function fetchData(): void {
            try {
                setLoading(true);
                const response = await customEventServices.fetch({});
                setOptions(
                    response?.map(item => {
                        return {
                            id: item.id,
                            name: item?.name
                        };
                    })
                );
            } catch (e) {
                console.log("Error: ", e?.response?.data?.error);
            } finally {
                setLoading(false);
            }
        }

        if (open && (search.length === 0 || search.length > 0)) {
            fetchData();
        }

    }, [search, open]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
            setSearch("");
        }
    }, [open]);

    const handleSearch = debounce(searchTerm => {
        setSearch(searchTerm);
    }, 800);

    const fieldError = inputName?.split(".")?.reduce((acc, key) => acc?.[key], errors);

    return (
        <Controller
            render={({field: {onChange, value, ...props}}) => (
                <Autocomplete
                    id={selectId}
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    getOptionDisabled={(option) => disabledOptions.includes(option.id)}
                    getOptionLabel={(option) => option?.name || ""}
                    options={options}
                    loading={loading}
                    fullWidth
                    slotProps={{paper: {sx: trafficSourceSelectPaperStyles}}}
                    value={value || null}
                    renderOption={(props, option) => {
                        const {key, ...optionProps} = props;
                        return <li {...optionProps} key={key}>{option.name}</li>;
                    }}
                    renderInput={params => (
                        <TextField {...params} error={!!fieldError} variant="outlined" size="small" fullWidth
                            helperText={fieldError ? 'Choose a custom conversion.' : undefined}
                            placeholder="Select custom conversion" label={inputLabel}
                            onChange={e => handleSearch(e.target.value)} slotProps={{inputLabel: {shrink: true}}}/>
                    )}
                    onChange={(e, data) => {
                        onChange(data);
                        updateOnChange();
                    }}
                    {...props}
                />
            )}
            rules={{required: true}}
            defaultValue={null}
            name={inputName}
            control={control}
            onChange={([, data]) => data}
        />
    );
}

export default ReactHookCustomConversionSelect;